import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
    selector: 'app-create-contract',
    templateUrl: './create-contract.component.html',
    styleUrls: ['./create-contract.component.scss']
})
export class CreateContractComponent {

    constructor(public dialogRef: MatDialogRef<CreateContractComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    step = 1;

    ok() {
        this.dialogRef.close({isOk: true});
    }

    cancel() {
        this.dialogRef.close({isCancel: true});
    }

    selectStep(value) {
        this.step = value;
    }
}
